import { render } from "./inscription-client.vue?vue&type=template&id=044ce214"
import script from "./inscription-client.vue?vue&type=script&lang=js"
export * from "./inscription-client.vue?vue&type=script&lang=js"

import "./inscription-client.vue?vue&type=style&index=0&id=044ce214&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__